import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].GET_EQUIPMENT_REGISTRATIONS]: {
		url: '/company/:companyId/equipment/:equipmentId/registrations/',
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].GET_EQUIPMENT_REGISTRATION]: {
		url: '/company/:companyId/equipment/:equipmentId/registrations/:registrationId/',
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].CREATE_EQUIPMENT_REGISTRATION]: {
		url: '/company/:companyId/equipment/:equipmentId/registrations/',
		requestOptions: {
			method: 'POST',
		},
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].PATCH_EQUIPMENT_REGISTRATION]: {
		url: '/company/:companyId/equipment/:equipmentId/registrations/:registrationId/',
		requestOptions: {
			method: 'PATCH',
		},
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].PUT_EQUIPMENT_REGISTRATION]: {
		url: '/company/:companyId/equipment/:equipmentId/registrations/:registrationId/',
		requestOptions: {
			method: 'PUT',
		},
	},

	[ModulesConfigMap[ModulesMap.EQUIPMENT_REGISTRATIONS].DELETE_EQUIPMENT_REGISTRATION]: {
		url: '/company/:companyId/equipment/:equipmentId/registrations/:registrationId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
}
